export default __webpack_public_path__ + "static/media/P17_robothead.b014a56b.jpg";